import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable, BehaviorSubject } from 'rxjs'

@Injectable()
export class ProfileService {
  jwt: any
  public isTokenRefreshing = new BehaviorSubject(false)

  constructor(private http: HttpClient) {}

  public fetchProfile(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/profile`
    return this.http.get(url)
  }

  public updatePassword(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/profile/updatePassword`
    return this.http.post(url, params)
  }
}
